import React from "react";
import { confirmable } from "react-confirm";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Divider,
} from "@material-ui/core";

const DialogTitle = ({ children, onClose }) => (
  <div
    className="d-flex flex-space-between flex-center"
    style={{ padding: "16px 24px" }}
  >
    <Typography variant="body" className="dialogTitle p-0 mt-25 dark:text-white">
      {children}
    </Typography>
  </div>
);

class ConfirmationNew extends React.Component {
  render() {
    const {
      okLabel = "OK",
      cancelLabel = "Cancel",
      title,
      confirmation,
      show,
      proceed,
      dismiss,
    } = this.props;

    return (
      <Dialog open={show} onClose={dismiss} fullWidth maxWidth="sm">
        <DialogTitle onClose={dismiss} className="dark:bg-[#1A1F2C] dark:text-white">{title || "Confirmation"}</DialogTitle>

        <Divider className="mt-15" />

        <DialogContent className="mb-10 dark:bg-[#1A1F2C]" style={{ fontWeight: "600" }}>
          <div
            style={{
              lineHeight: "20px",
              fontSize: "14px",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
            className="dark:text-[#F1F5F9]" 
          >
            {confirmation}
          </div>
        </DialogContent>

        <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
          <Button
            variant="outlined"
            onClick={() => proceed(false)}
            className="mr-10"
            style={{
              backgroundColor: "gray",
              color: "white",
              borderRadius: "5px",
              padding: "8px 16px",
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            variant="contained"
            onClick={() => proceed(true)}
            className="mr-5"
            style={{
              backgroundColor: "green",
              color: "white",
              borderRadius: "5px",
              padding: "8px 16px",
            }}
          >
            {okLabel}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default confirmable(ConfirmationNew);
